var _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstroLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_751_20944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0.772949H0V33.2275H31V0.772949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_751_20944)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_751_20944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 14,
    width: 31,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.397461 14.8447H31V26.8335C31 30.3648 28.153 33.2276 24.6411 33.2276H6.75644C3.24447 33.2276 0.397461 30.3648 0.397461 26.8335V14.8447Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_751_20944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 14.5664H31.001V21.0573H0.000976562V14.5664Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4746 38.096V7.26416H31.0009V38.096H24.4746Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000977952 38.096L0.000976562 7.26416H6.52729V38.096H0.000977952Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 26.7368H31.001V33.2277H0.000976562V26.7368Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52729 25.9258V33.2281H0.000976562V25.9258H6.52729Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000976562 21.0573H6.52729V14.5664H0.000976562V21.0573Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0009 33.2281V25.9258H24.4746V33.2281H31.0009Z",
    fill: "#1E88E5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2071 8.48975L0.532927 14.4715L0.197072 12.7864C-0.226096 10.6632 0.811183 8.66375 2.51389 8.32052L26.022 3.58175C27.7248 3.23851 29.4481 4.68145 29.8713 6.80466L30.2071 8.48975Z",
    fill: "#1E88E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstroLogo);
export default __webpack_public_path__ + "static/media/AstroLogo.415cf5c6578c53448a97081087687bd6.svg";
export { ForwardRef as ReactComponent };